import React from 'react';

import RichText from '@/components/ui/RichText/RichText';

import type { CardLabels } from '@/types/packageCard';

interface CardHeaderProps {
  badge?: string;
  title?: string;
  subtitle?: string;
  testsCount: number;
  showItemCount?: boolean;
  labels: CardLabels;
}

export default function CardHeader({
  badge,
  title,
  subtitle,
  testsCount,
  showItemCount = true,
  labels,
}: CardHeaderProps): React.ReactElement {
  const countLabel = labels.itemCountLabel?.content ?? 'Tests';

  return (
    <>
      {badge && <RichText styles={labels.badge?.styles}>{badge}</RichText>}

      <div className="flex items-center justify-between">
        <div>
          {title && <RichText styles={labels.title?.styles}>{title}</RichText>}
          {subtitle && (
            <RichText styles={labels.subtitle?.styles}>{subtitle}</RichText>
          )}
          {showItemCount && (
            <RichText styles={labels.testsCount?.styles}>
              {`${testsCount} ${countLabel}`}
            </RichText>
          )}
        </div>
      </div>
    </>
  );
}
